module.exports = __webpack_public_path__ + "img/im.ed29d9f.svg";